import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import { createRef } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { CostType } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getCostType } from '../calculationTypes';
import { getSelectedCalculationPricelistCurrency } from '../redux/calculationSelectors';

type OwnProps = {
    handleNameChange: (val: string) => void;
    handleAmountChange: (val: number) => void;
    useBasePrice: boolean;
    handleUseBasePrice: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    amount: number;
};

const mapStateToProps = (state: RootState) => ({
    isEditCostDialogLoading: state.calculation.isEditCostDialogLoading,
    currency: getSelectedCalculationPricelistCurrency(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PricePerPackageCostDialogContent = ({
    isEditCostDialogLoading,
    handleAmountChange,
    handleNameChange,
    useBasePrice,
    handleUseBasePrice,
    name,
    amount,
    currency
}: Props) => {
    const getAmountLabel = () => {
        return getCostType(currency, CostType.PerBox!);
    };
    const amountInputRef = createRef();

    return (
        <div>
            <Grid container direction="column">
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth={true}
                    onChange={e => handleNameChange(e.target.value)}
                    value={name}
                    disabled={isEditCostDialogLoading}
                />
                <NumberFormat
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    placeholder={getAmountLabel()}
                    decimalSeparator=","
                    thousandSeparator={false}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    isNumericString={true}
                    suffix={` ${getAmountLabel()}`}
                    disabled={isEditCostDialogLoading}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={useBasePrice}
                            onChange={handleUseBasePrice}
                            name="useBasePrice"
                            color="primary"
                            disabled={isEditCostDialogLoading}
                        />
                    }
                    label="Calculate using baseprice"
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(PricePerPackageCostDialogContent);
